import { TemplateType } from '~/types/template';

/**
 * Template types in GemPages that have 1:1 relationship between page and template.
 */
export const GP_ONE_TO_ONE_TEMPLATE_TYPES = [TemplateType.ARTICLE, TemplateType.PAGE];
